import { Component, OnInit } from '@angular/core';
import { ContentService } from '../../shared/content.service';

@Component({
  selector: 'app-mv',
  templateUrl: './mv.component.html',
  styleUrls: ['./mv.component.scss']
})
export class MvComponent implements OnInit {

  page: Object;
  
  constructor(private contentService: ContentService) { 
  }

  ngOnInit() {
    this.page = this.contentService.pages['mv'];
  }

}
